<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [hasDefault]="false"
  [isShowModal]="false"
  [columns]="hcolumns"
  (valueChange)="onChange($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content" *ngIf="columns !== undefined && columns.length > 0">
    <kgrid
      [label]="label"
      [areaName]="areaName"
      [columns]="columns"
      [gridViewData]="currentData"
      [isEdit]="false"
      reportName="InvBalance"
      pathPreFix="INV"
      (onDataStateChanged)="onDataStateChanged($event)"
      [isAdd]="false"
      [isDelete]="false"
      [isMulti]="false">
    </kgrid>
  </ng-container>
</dynamic-form>
